import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon, UserIcon, TrashIcon, LogOutIcon } from 'lucide-react';
export const UserProfile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={dropdownRef} data-id="element-194">
      <button onClick={() => setIsOpen(!isOpen)} className="p-4 w-full flex items-center gap-3 hover:bg-command-panel transition-colors border-t border-command-border" aria-expanded={isOpen} aria-haspopup="true" data-id="element-195">
        <div className="w-8 h-8 rounded-full bg-command-card flex items-center justify-center font-bold text-xs flex-shrink-0 text-[#4a90e2] border border-command-border" data-id="element-196">
          SM
        </div>
        <div className="flex flex-col min-w-0 flex-grow" data-id="element-197">
          <span className="font-medium text-left text-white text-sm" data-id="element-198">
            Sgt. Miller
          </span>
          <span className="text-[10px] text-[var(--text-tertiary)] text-left" data-id="element-199">
            Badge #4421
          </span>
        </div>
        <ChevronDownIcon size={16} className={`text-command-text-muted transition-transform duration-200 ${isOpen ? '' : 'rotate-180'}`} data-id="element-200" />
      </button>
      {isOpen && <div className="absolute bottom-full left-0 w-full bg-[#1a1a1a] border border-[#444444] rounded-t-lg shadow-lg overflow-hidden" data-id="element-201">
          <button className="w-full px-4 py-2.5 text-left hover:bg-[#2a2a2a] transition-colors flex items-center gap-2 text-sm" data-id="element-202">
            <UserIcon size={16} className="text-[#888888]" data-id="element-203" />
            <span data-id="element-204">Assistants</span>
          </button>
          <button className="w-full px-4 py-2.5 text-left hover:bg-[#2a2a2a] transition-colors flex items-center gap-2 text-sm" data-id="element-205">
            <TrashIcon size={16} className="text-[#888888]" data-id="element-206" />
            <span data-id="element-207">Clear History</span>
          </button>
          <button className="w-full px-4 py-2.5 text-left hover:bg-[#2a2a2a] transition-colors flex items-center gap-2 text-sm text-[#ff4444]" data-id="element-208">
            <LogOutIcon size={16} data-id="element-209" />
            <span data-id="element-210">Logout</span>
          </button>
        </div>}
    </div>;
};